import './dialog.svelte.css';
/* src\components\pixel\dialog.svelte generated by Svelte v3.55.1 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	compute_slots,
	create_in_transition,
	create_out_transition,
	create_slot,
	detach,
	element,
	empty,
	get_all_dirty_from_scope,
	get_slot_changes,
	group_outros,
	init,
	insert,
	listen,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_slot_base
} from "../../../_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher } from '../../../_snowpack/pkg/svelte.js';
import { fade } from '../../../_snowpack/pkg/svelte/transition.js';
const get_bottom_right_slot_changes = dirty => ({});
const get_bottom_right_slot_context = ctx => ({});
const get_title_slot_changes = dirty => ({});
const get_title_slot_context = ctx => ({});

// (27:0) {#if isOpen}
function create_if_block(ctx) {
	let div0;
	let div0_class_value;
	let div0_intro;
	let div0_outro;
	let t0;
	let div2;
	let t1;
	let div1;
	let t2;
	let div2_class_value;
	let div2_intro;
	let div2_outro;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*$$slots*/ ctx[6]["title"] && create_if_block_2(ctx);
	const default_slot_template = /*#slots*/ ctx[9].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);
	let if_block1 = /*$$slots*/ ctx[6]["bottom-right"] && create_if_block_1(ctx);

	return {
		c() {
			div0 = element("div");
			t0 = space();
			div2 = element("div");
			if (if_block0) if_block0.c();
			t1 = space();
			div1 = element("div");
			if (default_slot) default_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			attr(div0, "class", div0_class_value = "" + (/*className*/ ctx[4] + " modal-dialog-backdrop" + " svelte-oinbgn"));
			attr(div0, "style", /*backdropStyle*/ ctx[3]);
			attr(div2, "class", div2_class_value = "" + (/*className*/ ctx[4] + " modal-dialog" + " svelte-oinbgn"));
			attr(div2, "style", /*style*/ ctx[2]);
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t0, anchor);
			insert(target, div2, anchor);
			if (if_block0) if_block0.m(div2, null);
			append(div2, t1);
			append(div2, div1);

			if (default_slot) {
				default_slot.m(div1, null);
			}

			append(div2, t2);
			if (if_block1) if_block1.m(div2, null);
			current = true;

			if (!mounted) {
				dispose = listen(div0, "click", /*click_handler*/ ctx[10]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (!current || dirty & /*className*/ 16 && div0_class_value !== (div0_class_value = "" + (/*className*/ ctx[4] + " modal-dialog-backdrop" + " svelte-oinbgn"))) {
				attr(div0, "class", div0_class_value);
			}

			if (!current || dirty & /*backdropStyle*/ 8) {
				attr(div0, "style", /*backdropStyle*/ ctx[3]);
			}

			if (/*$$slots*/ ctx[6]["title"]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*$$slots*/ 64) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div2, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[8], dirty, null),
						null
					);
				}
			}

			if (/*$$slots*/ ctx[6]["bottom-right"]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*$$slots*/ 64) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div2, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*className*/ 16 && div2_class_value !== (div2_class_value = "" + (/*className*/ ctx[4] + " modal-dialog" + " svelte-oinbgn"))) {
				attr(div2, "class", div2_class_value);
			}

			if (!current || dirty & /*style*/ 4) {
				attr(div2, "style", /*style*/ ctx[2]);
			}
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (div0_outro) div0_outro.end(1);
				div0_intro = create_in_transition(div0, fade, {});
				div0_intro.start();
			});

			transition_in(if_block0);
			transition_in(default_slot, local);
			transition_in(if_block1);

			add_render_callback(() => {
				if (div2_outro) div2_outro.end(1);
				div2_intro = create_in_transition(div2, fade, {});
				div2_intro.start();
			});

			current = true;
		},
		o(local) {
			if (div0_intro) div0_intro.invalidate();
			div0_outro = create_out_transition(div0, fade, {});
			transition_out(if_block0);
			transition_out(default_slot, local);
			transition_out(if_block1);
			if (div2_intro) div2_intro.invalidate();
			div2_outro = create_out_transition(div2, fade, {});
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching && div0_outro) div0_outro.end();
			if (detaching) detach(t0);
			if (detaching) detach(div2);
			if (if_block0) if_block0.d();
			if (default_slot) default_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (detaching && div2_outro) div2_outro.end();
			mounted = false;
			dispose();
		}
	};
}

// (30:8) {#if $$slots["title"]}
function create_if_block_2(ctx) {
	let div;
	let current;
	const title_slot_template = /*#slots*/ ctx[9].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[8], get_title_slot_context);

	return {
		c() {
			div = element("div");
			if (title_slot) title_slot.c();
			attr(div, "class", "title svelte-oinbgn");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (title_slot) {
				if (title_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						title_slot,
						title_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(title_slot_template, /*$$scope*/ ctx[8], dirty, get_title_slot_changes),
						get_title_slot_context
					);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (39:8) {#if $$slots["bottom-right"]}
function create_if_block_1(ctx) {
	let div;
	let current;
	const bottom_right_slot_template = /*#slots*/ ctx[9]["bottom-right"];
	const bottom_right_slot = create_slot(bottom_right_slot_template, ctx, /*$$scope*/ ctx[8], get_bottom_right_slot_context);

	return {
		c() {
			div = element("div");
			if (bottom_right_slot) bottom_right_slot.c();
			attr(div, "class", "bottom-right svelte-oinbgn");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (bottom_right_slot) {
				bottom_right_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (bottom_right_slot) {
				if (bottom_right_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						bottom_right_slot,
						bottom_right_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(bottom_right_slot_template, /*$$scope*/ ctx[8], dirty, get_bottom_right_slot_changes),
						get_bottom_right_slot_context
					);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(bottom_right_slot, local);
			current = true;
		},
		o(local) {
			transition_out(bottom_right_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (bottom_right_slot) bottom_right_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*isOpen*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*isOpen*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*isOpen*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	const $$slots = compute_slots(slots);
	let { isOpen = false } = $$props;
	let { dismissable = false } = $$props;
	let { style = "" } = $$props;
	let { backdropStyle = "" } = $$props;
	let { className = "" } = $$props;

	function open() {
		$$invalidate(0, isOpen = true);
		dispatch("open");
	}

	function close() {
		$$invalidate(0, isOpen = false);
		dispatch("close");
	}

	let dispatch = createEventDispatcher();

	const click_handler = () => {
		if (dismissable) {
			close();
		}
	};

	$$self.$$set = $$props => {
		if ('isOpen' in $$props) $$invalidate(0, isOpen = $$props.isOpen);
		if ('dismissable' in $$props) $$invalidate(1, dismissable = $$props.dismissable);
		if ('style' in $$props) $$invalidate(2, style = $$props.style);
		if ('backdropStyle' in $$props) $$invalidate(3, backdropStyle = $$props.backdropStyle);
		if ('className' in $$props) $$invalidate(4, className = $$props.className);
		if ('$$scope' in $$props) $$invalidate(8, $$scope = $$props.$$scope);
	};

	return [
		isOpen,
		dismissable,
		style,
		backdropStyle,
		className,
		close,
		$$slots,
		open,
		$$scope,
		slots,
		click_handler
	];
}

class Dialog extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			isOpen: 0,
			dismissable: 1,
			style: 2,
			backdropStyle: 3,
			className: 4,
			open: 7,
			close: 5
		});
	}

	get open() {
		return this.$$.ctx[7];
	}

	get close() {
		return this.$$.ctx[5];
	}
}

export default Dialog;